import { Component } from '@angular/core';

@Component({
  selector: 'app-fd-empty-route-component',
  imports: [],
  standalone: true,
  template: ''

})
export class FdEmptyRouteComponentComponent {

}
